import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { AssignToUsersState } from "../types/state";

import * as ac from "./actions-creators";
import initialAssignToUsersState from "./initial-state";

const assignToUsersReducer = createReducer<AssignToUsersState, ActionType<typeof ac>>(initialAssignToUsersState)
    .handleAction(
        ac.fetchAssignableUsersAsync.request,
        (state): AssignToUsersState => ({
            ...state,
            areUsersBeingFetched: true,
            usersFetchError: initialAssignToUsersState.usersFetchError,
        }),
    )
    .handleAction(
        ac.fetchAssignableUsersAsync.success,
        (state, { payload }): AssignToUsersState => ({
            ...state,
            areUsersBeingFetched: false,
            users: payload,
        }),
    )
    .handleAction(
        ac.fetchAssignableUsersAsync.failure,
        (state, { payload }): AssignToUsersState => ({
            ...state,
            areUsersBeingFetched: false,
            usersFetchError: payload,
        }),
    )
    .handleAction(
        ac.assignToUserAsync.request,
        (state): AssignToUsersState => ({
            ...state,
            isAssignInProgress: true,
            assignError: initialAssignToUsersState.assignError,
        }),
    )
    .handleAction(
        ac.assignToUserAsync.success,
        (state): AssignToUsersState => ({
            ...state,
            isAssignInProgress: false,
            isShowAssignToUserModal: true,
        }),
    )
    .handleAction(
        ac.assignToUserAsync.failure,
        (state, { payload }): AssignToUsersState => ({
            ...state,
            isAssignInProgress: false,
            assignError: payload,
        }),
    )
    .handleAction(
        ac.setIsShowAssignToUserModal,
        (state, { payload }): AssignToUsersState => ({
            ...state,
            isShowAssignToUserModal: payload,
        }),
    );

export default assignToUsersReducer;
